<template>
  <nav>
    <div v-if="closeAllExpand">
      <div v-if="!isExpand">
        <v-navigation-drawer v-model="drawer" app dark :permanent="$vuetify.breakpoint.mdAndUp" min-width="300px"
          class="overflow-y-hidden" style="
            overflow-y: hidden !important;
            height: 100%;
            background: linear-gradient(
              90deg,
              rgb(32, 148, 205) 0%,
              rgb(31, 147, 204) 30%,
              rgb(27, 142, 202) 70%,
              rgb(27 141 201) 100%
            );
          ">
          <v-img src="@/assets/images/Group 214.svg" class="overflow-y-hidden">
            <v-list-item class="mt-xl-7 mt-lg-4 mt-xs-8">
              <img width="90" height="90" style="margin-left: auto; margin-right: auto" :src="$store.state.logoImage ? $store.state.logoImage : logo.image
                " />
            </v-list-item>
            <div style="text-align: center; color: #0fa7d8">
              <div class="d-flex justify-center">
                <v-toolbar-title style="
                    margin-bottom: 80px;
                    margin-top: 8px;
                    font-size: 12px;
                    color: #f99d20 !important;
                  ">
                  Powered by Optimistic
                </v-toolbar-title>
              </div>
            </div>
            <v-container class="overflow-y-auto">
              <v-list dense rounded style="
                  max-height: calc(100vh - 250px);
                  margin: 0px !important;
                  padding: 0px !important;
                ">
                <template v-for="item in items">
                  <v-list-group v-if="item.children" :key="item.text" v-model="item.model" v-show="item.Check == true"
                    append-icon="mdi-chevron-down-circle" @click="get1st(item.getid) && refresh()"
                    active-class="highlighted" :class="checkItems(item.getid) ? 'highlighted' : ''">
                    <template v-slot:append>
                      <v-img width="40" height="40" @click="show1 = !show1"
                        :src="show1 ? dwnimage.showdwn : dwnimage.hidedwn" alt></v-img>
                    </template>
                    <template v-slot:activator>
                      <v-img width="20" height="20" :src="item.icon"></v-img>
                      <v-list-item style="margin-left: 18px">
                        <v-list-item-content class="mt-1">
                          <v-list-item-title style="font-size: 15px">
                            {{ ParentsTanslate(item.text) }}
                            <!-- {{ $route.path }} -->
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>

                    <v-list-item v-model="getfirst" v-for="(child, i) in item.children" :key="i.text" exact
                      v-show="child.Checkitem == true" style="margin: 0" active-class="highlightedC" :class="child.route === $route.path ||
                        $route.path.indexOf(
                          item.children.map((x) => x.route)[i]
                        ) > -1
                        ? 'highlightedC'
                        : ''
                        ">
                      <v-divider style="
                          border-color: #fff;
                          margin-bottom: 0px;
                          margin-left: 10px;
                          margin-right: 30px;
                        " vertical></v-divider>
                      <v-list-item-action v-if="child.icon">
                        <v-icon>{{ child.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content style="margin-bottom: 0px; padding: 0">
                        <v-list-item @click="vali()" router :to="child.route">
                          <v-list-item-title style="font-size: 14px">{{ ChildTanslate(child.text) }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>

                  <v-list-group v-else :key="item.id" :append-icon="null" class="mt-1" active-class="highlighted" :class="item.route === $route.path ||
                    $route.path.indexOf(item.route) > -1
                    ? 'highlighted'
                    : ''
                    " v-show="item.Check == true" :group="item.route" @click.stop="
    item.model = true;
  refresh();
  get2nd(item.getid);
  " transition="none" aria-expanded="false">
                    <template v-slot:activator class="ma-0 pa-auto">
                      <v-list-item-action>
                        <img width="20px;" height="20px;" :src="item.icon" />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title style="font-size: 15px">
                          {{ HeadingTanslate(item) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-group>
                </template>
              </v-list>
            </v-container>
          </v-img>
        </v-navigation-drawer>
      </div>
      
      <div v-if="isExpand" @mouseover="mouseOver = true" @mouseleave="mouseOver = false">
        <v-navigation-drawer app style="
            background: transparent 0% 0% no-repeat padding-box;
            height: 100%;
            background: linear-gradient(
              90deg,
              rgb(32, 148, 205) 0%,
              rgb(31, 147, 204) 30%,
              rgb(27, 142, 202) 70%,
              rgb(27 141 201) 100%
            );
          " permanent dark mini-variant mini-variant-width="auto" class="d-flex justify-center mx-0">
          <v-img src="@/assets/images/Group 214.svg" width="130">
            <v-container class="px-2">
              <div class="d-flex justify-center">
                <v-avatar width="55" height="55" class="mt-4">
                  <v-img :src="$store.state.logoImage
                    ? $store.state.logoImage
                    : logo.image
                    "></v-img>
                </v-avatar>
              </div>
              <div style="text-align: center; color: #0fa7d8">
                <div class="d-flex justify-center mx-1">
                  <v-toolbar-title style="
                      margin-bottom: 55px;
                      margin-top: 15px;
                      font-size: 10px;
                      font-weight: 100;
                      color: #f99d20 !important;
                    ">
                    Powered by Optimistic
                  </v-toolbar-title>
                </div>
              </div>
            </v-container>
            
            <v-container class="overflow-y-auto" style="
                max-height: calc(100vh - 200px);
                margin: 0px !important;
                padding: 0px !important;
              ">
              <div v-for="item in items" v-bind:key="item.getid" class="d-flex row ma-1 justify-center mb-2 ex-menu">
                <!-- Child -->
                <v-menu v-if="item.children" open-on-hover offset-x bottom nav flat>
                  <template class="d-flex justify-center" v-slot:activator="{ on, attrs }">
                    <v-btn @click="get1st(item.getid)" v-on="on" v-show="item.Check == true" v-bind="attrs" depressed text
                      color="transparent" active-class="highlighted" :class="checkItems(item.getid) ? 'highlighted' : ''">
                      <img width="22" height="22" :src="item.icon" />
                    </v-btn>
                  </template>
                  <template class="pa-0">
                    <div v-for="(child, i) in item.children" :key="i" v-show="child.Checkitem == true">
                      <v-btn-toggle depressed v-model="getfirst" tile
                      borderless dense class="d-flex flex-row" active-class="highlightedT" :class="child.route === $route.path ||
                        $route.path.indexOf(
                          item.children.map((x) => x.route)[i]
                        ) > -1
                        ? 'highlightedT'
                        : ''
                        ">
                      <v-btn @click="vali()" router :to="child.route" width="100%" height="44px"
                        class="d-flex justify-start" style="
                          font-size: 15x !important;
                          font-weight: 80 !important;
                          text-transform: unset !important;" 
                          text exact>
                        {{ ChildTanslate(child.text) }}
                      </v-btn>
                    </v-btn-toggle>
                    </div>
                      
                    
                  </template>
                </v-menu>
                
                <!-- Heading -->
                <v-menu v-else open-on-hover offset-x bottom nav text active-class="highlighted"
                  :class="item.route === $route.path ? 'highlighted' : ''">
                  <template v-slot:activator="{ on, attrs }" class="d-flex justify-center" @click="
                    item.model = true;
                  refresh();
                  ">
                    <v-btn router :to="item.route" v-show="item.Check == true" depressed size="44px" color="transparent"
                      v-on="on" v-bind="attrs" active-class="highlighted"
                      :class="item.route === $route.path ? 'highlighted' : ''">
                      <img width="22" height="22" :src="item.icon" />
                    </v-btn>
                  </template>
                  <v-btn-toggle tile borderless dense class="d-flex flex-row justify-start flex-grow-1"
                    style="margin: 0; padding: 0" active-class="highlightedT" :class="item.route === $route.path ||
                      $route.path.indexOf(item.route) > -1
                      ? 'highlightedT'
                      : ''
                      ">
                    <v-btn @click="vali()" router :to="item.route" 
                      style="font-size: 15px !important; 
                      font-weight: 80;
                      text-transform: unset !important;" 
                      size="44px;"
                      text exact class="d-flex justify-start flex-grow-1">
                      {{ HeadingTanslate(item) }}
                    </v-btn>
                  </v-btn-toggle>
                </v-menu>

              </div>
            </v-container>
          </v-img>
        </v-navigation-drawer>
      </div>
    </div>

    <v-app-bar :style="borderButton" app color="white" height="80" style="z-index: 20;">
      <v-toolbar-title class="ml-2 mr-2">
        <div v-if="!closeAllExpand" style="text-align: center; color: #0fa7d8">
          <div class="d-flex justify-center" hidden>
            <v-avatar size="35" class="d-flex justify-center">
              <img :src="$store.state.logoImage ? $store.state.logoImage : logo.image
                " />
            </v-avatar>
          </div>
          <div class="d-flex justify-center mx-4">
            <v-toolbar-title style="
                margin-top: 5px;
                font-size: 10px;
                color: #f99d20 !important;
              ">
              Powered by Optimistic
            </v-toolbar-title>
          </div>
        </div>
      </v-toolbar-title>
      <div>
        <v-btn icon @click="
          (drawer = !drawer), (isExpand = !isExpand), (closeAllExpand = true)
          ">
          <img width="18px;" height="18px;" :src="image" />
        </v-btn>
      </div>

      <div class="hidden-sm-and-down">
        <v-btn icon @click="closeAllExpand = !closeAllExpand">
          <img width="20px;" height="20px;" :src="closeAllExpand ? expandImage.notExpand : expandImage.expand" />
        </v-btn>
      </div>
      
      <!-- Ads. 1 -->
      <div class="hidden-sm-and-down">
        <v-btn class="d-flex flex-wrap mx-4" text max-height="44px" max-width="280px" target="_blank"
          href="https://www.optimistic-app.com/documentation/">
          <v-img class="d-flex flex-wrap align-center white--text justify-center" height="44px" max-width="280px"
            src="@/assets/images/Group 8469.svg"><label style="
                height: fit-content;
                width: fit-content;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute !important;
                font-weight: 100;
                font-size: 16px;
                text-transform: capitalize;
                cursor: pointer;
              ">{{ $t("usageGuide") }}</label></v-img>
        </v-btn>
      </div>
      <!-- Ads. 2 -->
      <!-- <div>
          <v-btn
          class="d-flex flex-wrap mx-4" text max-height="44px" max-width="280px"
          target="_blank" href="https://www.optimistic-app.com/documentation/" > 
          <v-img class="d-flex flex-wrap align-center white--text justify-center"  
          height="44px" width="280px" src="@/assets/images/Group 8470.svg" 
          
          ><label   
              style=" height: fit-content; width: fit-content; top: 50%; left: 50%; transform: translate(-50%, -50%); 
              position:absolute !important; font-weight:100; font-size:16px; text-transform: capitalize;"
            >{{$t("Sample Ads. 2")}}</label></v-img>   
          </v-btn>
        </div> -->
      <v-spacer></v-spacer>
      <!-- add my task -->
      <div v-if="mytaskpermission.view == true">
        <router-link to="/mytask">
          <img src="@/assets/images/Group 3338.svg" width="20" height="30" class="mt-2" />
        </router-link>
      </div>
      
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn text dark v-on="on" @click="changeLang">
            <country-flag :country="currentflag" size="normal" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="lang" color="#F89D1F" dense>
            <v-list-item v-for="entry in languages" :key="entry.title"
              @click="changeLocale(entry.language, entry.flag, entry.title)">
              <v-list-item-action>
                <country-flag :country="entry.flag" size="normal" />
              </v-list-item-action>
              <v-list-item-title>{{ entry.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <div v-if="permission.view == true">
        <Noti />
      </div>

      <v-menu text nav offset-y max-width="180" class="d-flex flex-wrap mr-2">
        <template v-slot:activator="{ on }">
          <v-btn text v-ripple class="btnn d-flex flex-wrap text-capitalize justify-space-between" style="
              border-radius: 16px !important;
              color: #0fa7d8ff !important;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              background-color: #fff !important;
            " width="auto" height="50" depressed v-on="on" allow-overflow>
            <!-- <div class=" justify-start ma-0 pa-0"  style="margin:0% !important; padding:0% !important;">  -->
            <table>
              <tr>
                <td rowspan="2" style="color: #0fa7d8ff !important">
                  <v-badge offset-x="10" offset-y="10" color="green" bordered bottom overlap dot>
                    <v-list-item-avatar style="margin: 0% !important; padding: 0% !important" size="40">
                      <v-img style="margin: 0% !important; padding: 0% !important" :src="$store.state.profileimage != null
                        ? $store.state.profileimage
                        : ($store.state.profileimage =
                          'https://optimisticprdstorage.blob.core.windows.net/optimisticprdimages/Group 3166.png')
                        ">
                      </v-img>
                    </v-list-item-avatar>
                  </v-badge>
                </td>
                <td class="btnn text-truncate pa-0 justify-start hidden-sm-and-down" style="
                    text-align: left;
                    display: inline-block;
                    width: 110px;
                    color: #808495ff !important;
                    height: fit-content;
                    padding-left: 8px;
                  ">
                  {{ firstName }} &nbsp; {{ lastName }}
                </td>
              </tr>
              <tr class="hidden-sm-and-down">
                <td class="btnn d-inline-block text-truncate pa-0" style="
                    text-align: left;
                    color: #808495ff !important;
                    height: fit-content;
                    font-size: 12px;
                    font-weight: 100;
                    width: 110px;
                    padding-left: 8px;
                  ">
                  {{ roleID }}
                </td>
              </tr>
            </table>
          </v-btn>
        </template>
        <v-list text nav dense rounded min-width="180">
          <v-list-item dense rounded @click="logout()" class="included"
            style="color: #0fa7d8ff !important; opacity: 1 !important">
            <v-list-item-title style="
                color: #444444ff;
                font: 10px;
                padding-left: 5px;
                font-weight: 120;
              ">
              {{ $t("Logout") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </nav>
</template>

<script>
import i18n from "@/translate/i18n";
import CountryFlag from "vue-country-flag";
import Noti from "./Notification";
import axios from "axios";
import store from "@/store";
import enurl from "@/api/environment";
import CheckHomeStaffTimeAttPieChart_UpcomingTimeOff from "@/function/RolePermissions.js";
export default {
  mixins: [CheckHomeStaffTimeAttPieChart_UpcomingTimeOff],
  components: {
    CountryFlag,
    Noti,
  },
  data: () => ({
    permission: {
      view: true,
    },
    mytaskpermission: {
      view: true,
    },
    url: enurl.apiUrl,
    isExpand: false,
    mouseOver: false,
    username: store.state.username,
    firstName: store.state.firstName,
    lastName: store.state.lastName,
    roleID: store.state.roleID,
    closeAllExpand: true,
    currentflag: "",
    currentLangTitle: "",
    dialog: false,
    drawer: null,
    lang: null,
    getfirst: 0,
    thaiFlagIcon: true,
    engFlagIcon: false,
    languages: [
      { flag: "th", language: "th", title: "ประเทศไทย" },
      { flag: "us", language: "en", title: "English" },
      { flag: "CN", language: "cn", title: "中文" },
      { flag: "VN", language: "vn", title: "Tiếng Việt" },
      { flag: "MM", language: "mm", title: "မြန်မာဘာသာ" },
    ],
    show1: false,
    logo: {
      image: require("@/assets/images/logo@2x.png"),
    },
    image: require("@/assets/images/Icon material-menu.png"),
    expandImage: {
      expand: require("@/assets/images/Group 3720.png"),
      notExpand: require("@/assets/images/Icon ionic-ios-qr-scanner.png"),
    },
    dwnimage: {
      showdwn: require("@/assets/images/Mask Group 162@2x.png"),
      hidedwn: require("@/assets/images/Mask Group 161@2x.png"),
    },
    mygg: [],
  }),
  computed: {
    borderButton() {
      let color = store.state.color_Code;
      if (color) {
        return {
          "border-bottom": `3px solid ${color} !important`,
        };
      }
      return true;
    },
    HeadingTanslate() {
      return function (salut) {
        let value = salut.text;
        return value == "Home"
          ? this.$t("home")
          : value == "Dashboard"
            ? this.$t("Dashboard")
            : this.$t("VersionAndRelease");
      };
    },
    ParentsTanslate() {
      return function (salut) {
        let value = salut;
        return value == "Time Attendance"
          ? this.$t("TimeAttendance")
          : value == "Time Off"
            ? this.$t("Leave")
            : value == "Setting"
              ? this.$t("Systemsetting")
              : value == "Self Service"
                ? this.$t("Selfservice")
                : value == "Reports"
                  ? this.$t("Reports")
                  : value == "Organization"
                    ? this.$t("organization")
                    : value == "Personnel Management"
                      ? this.$t("PersonnelManagement")
                      : this.$t("Payroll");
      };
    },
    ChildTanslate() {
      return function (salut) {
        let value = salut;
        return value == "Time Entries"
          ? this.$t("timeEntries")
          : value == "Staff Time Attendance"
            ? this.$t("StaffTimeAttendance")
            : value == "My OT Request"
              ? this.$t("MyOTRequest")
              : value == "Employees OT Request"
                ? this.$t("EmployeesOTRequest")
                : value == "Setting"
                  ? this.$t("Setting")
                  : value == "Employees Time Off Request"
                    ? this.$t("EmployeesLeaveRequest")
                    : value == "My Time Off Request"
                      ? this.$t("MyTimeOffRequest")
                      : value == "Awaiting Approval"
                        ? this.$t("AwaitingApproval")
                        : value == "Payroll"
                          ? this.$t("Payroll")
                          : value == "User Management"
                            ? this.$t("Permissionmng")
                            : value == "Personal Profile"
                              ? this.$t("Personal_profile")
                              : value == "Sync Time Data"
                                ? this.$t("synctimedata")
                                : value == "Brand Identity"
                                  ? this.$t("BrandIdentity")
                                  : value == "Default Language"
                                    ? this.$t("DefaultLanguage")
                                    : value == "Change Password"
                                      ? this.$t("changepassword")
                                      : value == "Salary Document"
                                        ? this.$t("salarydocument")
                                        : value == "Help And Feedback"
                                          ? this.$t("HelpandFeedback")
                                          : value == "Employment"
                                            ? this.$t("EmploymentReport")
                                            : value == "Time Attendance"
                                              ? this.$t("TimeAttendanceReport")
                                              : value == "Time Off Report"
                                                ? this.$t("TimeOffReport")
                                                : value == "Annual Report"
                                                  ? this.$t("AnnualReport")
                                                  : value == "Company Profile"
                                                    ? this.$t("companyprofile")
                                                    : value == "Organization"
                                                      ? this.$t("NewOrganization")
                                                      : value == "Attendance"
                                                        ? this.$t("attendance")
                                                        : value == "Time Off"
                                                          ? this.$t("LeaveType")
                                                          : value == "Payroll Setting"
                                                            ? this.$t("PayrollSetting")
                                                            : value == "Common Master"
                                                              ? this.$t("commonmaster")
                                                              : value == "Employee"
                                                                ? this.$t("employee")
                                                                : value == "Shift Assignment"
                                                                  ? this.$t("ShiftAssignment")
                                                                  : value == "Usage Plan"
                                                                    ? this.$t("usageplan")
                                                                    : this.$t("othersetting");
      };
    },
    items() {
      return [
        {
          getid: 0,
          icon: require("@/assets/images/home.svg"),
          text: "Home",
          color: "#000",
          route: "/home",
          Check: false,
        },
        {
          getid: 1,
          icon: require("@/assets/images/Mask Group 176@2x.png"),
          text: "Organization",
          color: "#000",
          Check: false,
          children: [
            {
              text: "Company Profile",
              route: "/organization/companyprofile/companyinformation",
              Checkitem: false,
            },
            {
              text: "Organization",
              route: "/organization/org/department",
              Checkitem: false,
            },
            {
              text: "Attendance",
              route: "/organization/attendance/workinlocation",
              Checkitem: false,
            },
            {
              text: "Time Off",
              route: "/organization/leavetype",
              Checkitem: false,
            },
            {
              text: "Payroll Setting",
              route: "/organization/payrollsetting",
              Checkitem: false,
            },
            {
              text: "Common Master",
              route: "/masterdata",
              Checkitem: false,
            },
          ],
        },
        {
          getid: 2,
          icon: require("@/assets/images/list employee manage active.svg"),
          color: "#000",
          text: "Personnel Management",
          Check: false,
          children: [
            {
              text: "Employee",
              route: "/PersonnelManagement",
              Checkitem: false,
            },
            {
              text: "Shift Assignment",
              route: "/shiftassignment",
              Checkitem: false,
            }
          ],
        },
        // {
        //   getid: 2,
        //   icon: require("@/assets/images/list employee manage active.svg"),
        //   color: "#000",
        //   text: "Personnel Management",
        //   route: "/PersonnelManagement",
        //   Check: false,
        // },
        {
          getid: 3,
          icon: require("@/assets/images/list TimeAttendance active.svg"),
          color: "#000",
          text: "Time Attendance",
          model: false,
          Check: false,
          children: [
            {
              text: "Staff Time Attendance",
              route: "/StaffTimeAttendance",
              Checkitem: false,
            },
            {
              text: "Sync Time Data",
              route: "/SyncTimedata",
              Checkitem: false,
            },
            {
              text: "Employees OT Request",
              route: "/EmployeeOTrequest",
              Checkitem: false,
            },
            // {
            //   text: "Setting",
            //   route: "/TimeAttendance/Setting/timeworkdaycalendar",
            //   Checkitem: false,
            // },
          ],
        },
        {
          getid: 4,
          icon: require("@/assets/images/list Time off active.svg"),
          text: "Time Off",
          color: "#000",
          model: false,
          Check: false,
          children: [
            {
              text: "Employees Time Off Request",
              route: "/EmployeesTimeOffRequest",
              Checkitem: false,
            },
            // {
            //   text: "Setting",
            //   route: "/TimeOff/Setting/TimeOffTap",
            //   Checkitem: false,
            // },
          ],
        },
        {
          getid: 5,
          icon: require("@/assets/images/list Payroll active.svg"),
          text: "Payroll",
          color: "#000",
          model: false,
          Check: false,
          children: [
            {
              text: "Payroll",
              route: "/Payrolls",
              Checkitem: false,
            },
            {
              text: "Setting",
              route: "/PayRoll/Setting/payrollcalculationperiod",
              Checkitem: false,
            },
          ],
        },
        {
          getid: 6,
          icon: require("@/assets/images/dashboard-svgrepo-com.svg"),
          text: "Dashboard",
          color: "#000",
          route: "/dashboard",
          Check: true,
        },
        {
          getid: 7,
          icon: require("@/assets/images/report.svg"),
          text: "Reports",
          color: "#000",
          route: "/reports",
          Check: false,
          children: [
            {
              text: "Employment",
              route: "/employmentreport",
              Checkitem: false,
            },
            {
              text: "Time Attendance",
              route: "/timeattendancereport",
              Checkitem: false,
            },
            {
              text: "Time Off Report",
              route: "/timeoffreport",
              Checkitem: false,
            },
            {
              text: "Payroll",
              route: "/payrollreport",
              Checkitem: false,
            },
            {
              text: "Annual Report",
              route: "/annualreport",
              Checkitem: false,
            },
          ],
        },

        // {
        //   getid: 6,
        //   icon: require("@/assets/images/Mask Group 176@2x.png"),
        //   text: "Master Data",
        //   color: "#000",
        //   route: "/masterdata",
        //   Check: false,
        // },

        {
          getid: 8,
          icon: require("@/assets/images/Mask Group 149@2x.png"),
          text: "Setting",
          color: "#000",
          model: false,
          Check: false,
          children: [
            {
              text: "User Management",
              route: "/usermanagement/usergroup",
              Checkitem: false,
            },
            {
              text: "Other Setting",
              route: "/OtherSetting",
              Checkitem: false,
            },
            {
              text: "Default Language",
              route: "/DefaultLanguage",
              Checkitem: false,
            },

            {
              text: "Help And Feedback",
              route: "/HelpFeedback/NewFeedback",
              Checkitem: false,
            },
            {
              text: "Usage Plan",
              route: "/UsagePlan",
              Checkitem: true,
            },
          ],
        },
        {
          getid: 9,
          icon: require("@/assets/images/account@2x.png"),
          text: "Self Service",
          color: "#000",
          model: false,
          Check: false,
          children: [
            {
              text: "Personal Profile",
              route: "/selfservice/PersonalProfile/PersonalInformation",
              Checkitem: false,
            },
            {
              text: "Time Entries",
              route: "/selfservice/timeentries",
              Checkitem: false,
            },
            {
              text: "My OT Request",
              route: "/selfservice/myotrequest",
              Checkitem: false,
            },
            {
              text: "My Time Off Request",
              route: "/selfservice/mytimeoffrequest",
              Checkitem: false,
            },
            {
              text: "Salary Document",
              route: "/selfservice/salarydocument",
              Checkitem: false,
            },
            {
              text: "Change Password",
              route: "/selfservice/changepassword",
              Checkitem: false,
            },
          ],
        },
        {
          getid: 10,
          icon: require("@/assets/images/Component 191 – 2.svg"),
          text: "Version And Release",
          color: "#000",
          route: "/Version",
          Check: false,
        },
        
      ];
    },
    get1st() {
      return function (id) {
        // localStorage.clear();
        for (let j = 0; j < this.items[id].children.length; j++)
        {
          if (this.items[id].children[j].Checkitem == true)
          {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            return this.$router
              .push(this.items[id].children[j].route)
              .catch(() => { });
          }
        }
      };
    },
  },
  mounted: function () {
    let self = this;
    //console.log(sessionStorage,"localStorage",localStorage)
    if (localStorage.Templang === "English")
    {
      self.lang = 1;
      i18n.locale = "en";
      self.currentflag = "us";
      self.currentLangTitle = "English";
      document.cookie = "lang=" + i18n.locale;
      document.cookie = "flag=" + self.currentflag;
      document.cookie = "title=" + self.currentLangTitle;
    }
    else if (localStorage.Templang === "ประเทศไทย")
    {
      self.lang = 0;
      i18n.locale = "th";
      self.currentflag = "th";
      self.currentLangTitle = "ประเทศไทย";
      document.cookie = "lang=" + i18n.locale;
      document.cookie = "flag=" + self.currentflag;
      document.cookie = "title=" + self.currentLangTitle;
    }
    else if (localStorage.Templang === "Tiếng Việt")
    {
      self.lang = 3;
      i18n.locale = "vn";
      self.currentflag = "VN";
      self.currentLangTitle = "Tiếng Việt";
      document.cookie = "lang=" + i18n.locale;
      document.cookie = "flag=" + self.currentflag;
      document.cookie = "title=" + self.currentLangTitle;
    }
    else if (localStorage.Templang === "中文")
    {
      self.lang = 2;
      i18n.locale = "cn";
      self.currentflag = "CN";
      self.currentLangTitle = "中文";
      document.cookie = "lang=" + i18n.locale;
      document.cookie = "flag=" + self.currentflag;
      document.cookie = "title=" + self.currentLangTitle;
    }
    else if(localStorage.Templang === 'မြန်မာဘာသာ')
    {
      self.lang = 4;
      i18n.locale = "mm";
      self.currentflag = "MM";
      self.currentLangTitle = "မြန်မာဘာသာ";
      document.cookie = "lang=" + i18n.locale;
      document.cookie = "flag=" + self.currentflag;
      document.cookie = "title=" + self.currentLangTitle;
    }
    self.GetPersonal();
    //notification permission
    self.permission = self.CheckHomeStaffTimeAttPieChart_UpcomingTimeOff(163);
    //My Task permission
    self.mytaskpermission = self.CheckHomeStaffTimeAttPieChart_UpcomingTimeOff(164);
    //Menu Manage depend on role
    //Default some menu for customer admin /hr
    let roleid = sessionStorage.getItem("roleID");
    let perid = sessionStorage.getItem("permissionID").split(",");
    if (roleid == "Admin")
    {
      //Home
      self.items[0].Check = true;
      // Organization
      self.items[1].Check = true;
      if (self.items[1].children)
      {
        self.items[1].children[0].Checkitem = true;
        self.items[1].children[1].Checkitem = true;
        self.items[1].children[2].Checkitem = true;
        self.items[1].children[3].Checkitem = true;
        self.items[1].children[4].Checkitem = true;
        self.items[1].children[5].Checkitem = true;
      }

      //Personnel Management
      self.items[2].Check = true;
      if (self.items[2].children)
      {
        self.items[2].children[0].Checkitem = true;
        self.items[2].children[1].Checkitem = true;
      }

      //Time Attendance
      self.items[3].Check = true;
      if (self.items[3].children)
      {
        self.items[3].children[0].Checkitem = true;
        self.items[3].children[1].Checkitem = true;
        self.items[3].children[2].Checkitem = true;
        // self.items[3].children[3].Checkitem = true;
      }

      //Time Off
      self.items[4].Check = true;
      if (self.items[4].children)
      {
        self.items[4].children[0].Checkitem = true;
      }

      //Payroll
      self.items[5].Check = true;
      if (self.items[5].children)
      {
        self.items[5].children[0].Checkitem = true;
        self.items[5].children[1].Checkitem = true;
      }

      //Dashboard
      self.items[6].Check = true;

      //Reports
      self.items[7].Check = true;
      if (self.items[7].children)
      {
        self.items[7].children[0].Checkitem = true;
        self.items[7].children[1].Checkitem = false;
        self.items[7].children[2].Checkitem = true;
        self.items[7].children[3].Checkitem = true;
        self.items[7].children[4].Checkitem = true;
      }
      //Master Data
      // self.items[6].Check = true;
      //Setting
      self.items[8].Check = true;
      if (self.items[8].children)
      {
        self.items[8].children[0].Checkitem = true;
        self.items[8].children[1].Checkitem = true;
        self.items[8].children[2].Checkitem = true;
        self.items[8].children[3].Checkitem = true;
        self.items[8].children[4].Checkitem = true;
      }

      //Self Service
      self.items[9].Check = true;
      if (self.items[9].children)
      {
        self.items[9].children[0].Checkitem = true;
        self.items[9].children[1].Checkitem = true;
        self.items[9].children[2].Checkitem = true;
        self.items[9].children[3].Checkitem = true;
        self.items[9].children[4].Checkitem = true;
        self.items[9].children[5].Checkitem = true;
      }

      //Version And Release
      self.items[10].Check = true;
    }

    if (roleid == "HR")
    {
      //Home
      self.items[0].Check = true;
      // Organization
      self.items[1].Check = true;
      if (self.items[1].children)
      {
        self.items[1].children[0].Checkitem = true;
        self.items[1].children[1].Checkitem = true;
        self.items[1].children[2].Checkitem = true;
        self.items[1].children[3].Checkitem = true;
        self.items[1].children[4].Checkitem = true;
        self.items[1].children[5].Checkitem = true;
      }
      //Personnel Management
      self.items[2].Check = true;
      if (self.items[2].children)
      {
        self.items[2].children[0].Checkitem = true;
        self.items[2].children[1].Checkitem = true;
      }
      //Time Attendance
      self.items[3].Check = true;
      if (self.items[3].children)
      {
        self.items[3].children[0].Checkitem = true;
        self.items[3].children[1].Checkitem = true;
        self.items[3].children[2].Checkitem = true;
        // self.items[3].children[3].Checkitem = true;
      }

      //Time Off
      self.items[4].Check = true;
      if (self.items[4].children)
      {
        self.items[4].children[0].Checkitem = true;
      }

      //Payroll
      self.items[5].Check = true;
      if (self.items[5].children)
      {
        self.items[5].children[0].Checkitem = true;
        self.items[5].children[1].Checkitem = true;
      }

      //Dashboard
      self.items[6].Check = true;

      //Reports
      self.items[7].Check = true;
      if (self.items[7].children)
      {
        self.items[7].children[0].Checkitem = true;
        self.items[7].children[1].Checkitem = false;
        self.items[7].children[2].Checkitem = true;
        self.items[7].children[3].Checkitem = true;
        self.items[7].children[4].Checkitem = true;
      }
      //Master Data
      // self.items[6].Check = true;
      //Setting
      self.items[8].Check = true;
      if (self.items[8].children)
      {
        self.items[8].children[0].Checkitem = false;
        self.items[8].children[1].Checkitem = true;
        self.items[8].children[2].Checkitem = true;
        self.items[8].children[3].Checkitem = true;
        self.items[8].children[4].Checkitem = true;
      }
      //Self Service
      self.items[9].Check = true;
      if (self.items[9].children) {
        self.items[9].children[0].Checkitem = true;
        self.items[9].children[1].Checkitem = true;
        self.items[9].children[2].Checkitem = true;
        self.items[9].children[3].Checkitem = true;
        self.items[9].children[4].Checkitem = true;
        self.items[9].children[5].Checkitem = true;
      }

      //Version And Release
      self.items[10].Check = true;
    }

    //if not customer admin
    //Home
    if (perid.some((e) => e == 1)) {
      self.items[0].Check = true;
    }
    // Organization
    if (
      perid.some(
        (e) =>
          e == 116 ||
          e == 99 ||
          e == 54 ||
          e == 59 ||
          e == 20 ||
          e == 23 ||
          e == 30 ||
          e == 35 ||
          e == 89 ||
          e == 39 ||
          e == 64 ||
          e == 79 ||
          e == 69 ||
          e == 74 ||
          e == 84 ||
          e == 94 ||
          e == 168 ||
          e == 228 ||
          e == 230
      )
    ) {
      self.items[1].Check = true;
      if (self.items[1].children) {
        if (perid.some((e) => e == 116 || e == 99 || e == 228)) {
          self.items[1].children[0].Checkitem = true;
        }
        if (perid.some((e) => e == 54 || e == 59)) {
          self.items[1].children[1].Checkitem = true;
        }
        if (
          perid.some((e) => e == 20 || e == 30 || e == 35)
        ) {
          self.items[1].children[2].Checkitem = true;
        }
        if (perid.some((e) => e == 89)) {
          self.items[1].children[3].Checkitem = true;
        }
        if (perid.some((e) => e == 230)) {
          self.items[1].children[4].Checkitem = true;
        }
        if (
          perid.some(
            (e) =>
              e == 64 ||
              e == 79 ||
              e == 69 ||
              e == 74 ||
              e == 84 ||
              e == 94 ||
              e == 168
          )
        ) {
          self.items[1].children[5].Checkitem = true;
        }
      }
    }
    //Personal Management
    if (perid.some((e) => e == 7 || e == 27)) {

      self.items[2].Check = true;
      if (self.items[2].children) {
        if (perid.some((e) => e == 7)) {
          self.items[2].children[0].Checkitem = true;
        }
        if (perid.some((e) => e == 27)) {
          self.items[2].children[1].Checkitem = true;
        }
      }
    }

    //Time Attendance
    if (perid.some((e) => e == 10 || e == 14 || e == 18)) {
      self.items[3].Check = true;
      if (self.items[3].children) {
        if (perid.some((e) => e == 10)) {
          self.items[3].children[0].Checkitem = true;
        }
        if (perid.some((e) => e == 14)) {
          self.items[3].children[1].Checkitem = true;
        }
        if (perid.some((e) => e == 18)) {
          self.items[3].children[2].Checkitem = true;
        }

        // if (
        //   perid.some((e) => e == 20 || e == 23 || e == 27 || e == 30 || e == 35)
        // ) {
        //   self.items[3].children[3].Checkitem = true;
        // }
      }
    }

    //Time Off
    if (perid.some((e) => e == 37)) {
      self.items[4].Check = true;
      if (self.items[4].children) {
        if (perid.some((e) => e == 37)) {
          self.items[4].children[0].Checkitem = true;
        }
        // if (perid.some((e) => e == 39)) {
        //   self.items[4].children[1].Checkitem = true;
        // }
      }
    }

    //payroll
    if (perid.some((e) => e == 41 || e == 45 || e == 197)) {
      self.items[5].Check = true;
      if (self.items[5].children) {
        if (perid.some((e) => e == 41)) {
          self.items[5].children[0].Checkitem = true;
        }
        if (perid.some((e) => e == 45 || e == 197)) {
          self.items[5].children[1].Checkitem = true;
        }
      }
    }

    //Dashboard
    self.items[6].Check = true;

    //Reports
    if (
      perid.some(
        (e) =>
          e == 172 ||
          e == 174 ||
          e == 176 ||
          e == 178 ||
          e == 180 ||
          e == 182 ||
          e == 184 ||
          e == 186 ||
          e == 225
      )
    ) {
      self.items[7].Check = true;
      if (self.items[7].children) {
        if (perid.some((e) => e == 172 || e == 174 || e == 176)) {
          self.items[7].children[0].Checkitem = true;
        }
        if (perid.some((e) => e == 225)) {
          self.items[7].children[1].Checkitem = false;
        }
        if (perid.some((e) => e == 182)) {
          self.items[7].children[2].Checkitem = true;
        }
        if (perid.some((e) => e == 178 || e == 180 || e == 184)) {
          self.items[7].children[3].Checkitem = true;
        }
        if (perid.some((e) => e == 186)) {
          self.items[7].children[4].Checkitem = true;
        }
      }
    }

    //Master Data
    // if (
    //   perid.some(
    //     (e) =>
    //       // e == 49 ||
    //       e == 54 ||
    //       e == 59 ||
    //       e == 64 ||
    //       e == 69 ||
    //       e == 74 ||
    //       e == 79 ||
    //       e == 84 ||
    //       e == 89 ||
    //       e == 94 ||
    //       e == 99 ||
    //       e == 168
    //   )
    // ) {
    //   self.items[6].Check = true;
    // }

    //Setting

    if (
      perid.some(
        (e) =>
          e == 107 || e == 111 || e == 112 || e == 118 || e == 120 || e == 195 || e == 227
      )
    ) {
      self.items[8].Check = true;
      if (self.items[8].children) {
        if (perid.some((e) => e == 107 || e == 111 || e == 112)) {
          self.items[8].children[0].Checkitem = true;
        }
        // if (perid.some((e) => e == 116)) {
        //   self.items[8].children[1].Checkitem = true;
        // }
        if (perid.some((e) => e == 195)) {
          self.items[8].children[1].Checkitem = true;
        }
        if (perid.some((e) => e == 118)) {
          self.items[8].children[2].Checkitem = true;
        }
        if (perid.some((e) => e == 120)) {
          self.items[8].children[3].Checkitem = true;
        }
        if (perid.some((e) => e == 227)) {
          self.items[8].children[4].Checkitem = true;
        }
      }
    }

    //Self Service

    if (
      perid.some(
        (e) =>
          e == 123 ||
          e == 126 ||
          e == 129 ||
          e == 132 ||
          e == 136 ||
          e == 139 ||
          e == 143 ||
          e == 146 ||
          e == 149 ||
          e == 152 ||
          e == 155 ||
          e == 159 ||
          e == 188 ||
          e == 232
      )
    ) {
      self.items[9].Check = true;
      if (self.items[9].children) {
        if (
          perid.some(
            (e) =>
              e == 123 ||
              e == 126 ||
              e == 129 ||
              e == 132 ||
              e == 136 ||
              e == 139 ||
              e == 143 ||
              e == 146 ||
              e == 149
          )
        ) {
          self.items[9].children[0].Checkitem = true;
        }
        if (perid.some((e) => e == 152)) {
          self.items[9].children[1].Checkitem = true;
        }
        if (perid.some((e) => e == 155)) {
          self.items[9].children[2].Checkitem = true;
        }
        if (perid.some((e) => e == 159)) {
          self.items[9].children[3].Checkitem = true;
        }
        if (perid.some((e) => e == 232)) {
          self.items[9].children[4].Checkitem = true;
        }
        if (perid.some((e) => e == 188)) {
          self.items[9].children[5].Checkitem = true;
        }
      }
    }
    //Version And Release
    if (perid.some((e) => e == 167)) {
      self.items[10].Check = true;
    }
  },
  watch: {
    "$route.path"(newValue) {
      this.items.forEach((item, i) => {
        if (item.children && item.children.length) {
          if (
            item.children.map((x) => x.route).some((x) => newValue.includes(x))
          ) {
            this.items[i].model = true;
          }
        }
      });
    },
  },
  methods: {
    changeLang() {
      if (localStorage.Templang == "English") {
        self.lang = 1;
        i18n.locale = "en";
        self.currentflag = "us";
        self.currentLangTitle = "English";
      } else if (localStorage.Templang == "ประเทศไทย") {
        self.lang = 0;
        i18n.locale = "th";
        self.currentflag = "th";
        self.currentLangTitle = "ประเทศไทย";
      } else if (localStorage.Templang == "Tiếng Việt") {
        self.lang = 3;
        i18n.locale = "vn";
        self.currentflag = "VN";
        self.currentLangTitle = "Tiếng Việt";
      } else if (localStorage.Templang == "中文") {
        self.lang = 2;
        i18n.locale = "cn";
        self.currentflag = "CN";
        self.currentLangTitle = "中文";
      } else if (localStorage.Templang == "မြန်မာဘာသာ") {
        self.lang = 4;
        i18n.locale = "mm";
        self.currentflag = "MM";
        self.currentLangTitle = "မြန်မာဘာသာ";
      } else {
        if (sessionStorage.flag == "English") {
          self.lang = 1;
          i18n.locale = "en";
          self.currentflag = "us";
          self.currentLangTitle = "English";
        } else if (sessionStorage.flag == "Thai") {
          self.lang = 0;
          i18n.locale = "th";
          self.currentflag = "th";
          self.currentLangTitle = "ประเทศไทย";
        } else if (sessionStorage.flag == "Vietnam") {
          self.lang = 3;
          i18n.locale = "vn";
          self.currentflag = "VN";
          self.currentLangTitle = "Tiếng Việt";
        } else if (sessionStorage.flag == "Chinese") {
          self.lang = 2;
          i18n.locale = "cn";
          self.currentflag = "CN";
          self.currentLangTitle = "中文";
        } else {
          self.lang = 4;
          i18n.locale = "mm";
          self.currentflag = "MM";
          self.currentLangTitle = "မြန်မာဘာသာ";
        }
      }
    },
    checkItems(item) {
      for (var i in this.items[item].children) {
        if (
          this.items[item].children.map((x) => x.route)[i] ===
          this.$route.path ||
          this.$route.path.indexOf(
            this.items[item].children.map((x) => x.route)[i]
          ) > -1
        ) {
          return true;
        }
      }
    },
    get2nd(id) {
      this.$router.push(this.items[id].route).catch(() => { });
    },
    GetPersonal() {
      let self = this;
      let tempp = {
        company_ID: store.state.companyID,
        employee_ID: store.state.employeeID,
      };
      axios
        .post(`${self.url}PersonalInfo/GetShortInfo`, tempp)
        .then(function (response) {
          self.mygg = response.data.data;
          self.profileimage = response.data.data.map((x) => x.image);
          if (self.profileimage.length == 0) {
            self.profileimage =
              "https://optimisticprdstorage.blob.core.windows.net/optimisticprdimages/Group 3166.png";
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    changeLocale(locale, flag, title) {
      this.currentflag = flag;
      i18n.locale = locale;
      this.currentLangTitle = title;
      localStorage.setItem("Templang", title);
      //sessionStorage.setItem("flag", flag);
      //sessionStorage.setItem("title", title);
    },

    logout() {
      let self = this;
      self.$store
        .dispatch("logout")
        .then(() => {
          self.$router.push("/").catch(() => { });
          let expire = "Thu, 01 Jan 1970 00:00:00 GMT;";
          document.cookie = "username=;" + ";expires=" + expire;
          document.cookie = "password=;" + ";expires=" + expire;
          document.cookie = "abb=;" + ";expires=" + expire;
          document.cookie = "rememberme=false";
        })
        .catch((err) => alert(err));
    },
    vali() {
      localStorage.setItem("temp_tabs", 0);
      localStorage.setItem("pagenum", 1);
      localStorage.removeItem("get_date_of_today_return");
      localStorage.removeItem("get_date_of_today_return1");
      localStorage.removeItem("locktab");
    },
    refresh() {
      //shif assignment page
      let self = this;
      //localStorage.clear();
      localStorage.removeItem("mysalary");
      localStorage.removeItem("PerAllowance");
      localStorage.removeItem("gf");
      localStorage.removeItem("gg");
      localStorage.removeItem("mydisable");
      localStorage.removeItem("showforpersonalprofile");
      localStorage.removeItem("showforeditpersonal");
      localStorage.removeItem("showforeditpersonalprofile");
      localStorage.removeItem("localprofile");
      localStorage.removeItem("empcode");
      localStorage.removeItem("reportinfo");
      localStorage.removeItem("ww");
      localStorage.removeItem("ii");
      localStorage.removeItem("localworkpermitUrl");
      localStorage.removeItem("workpermitname");
      localStorage.removeItem("localworkeditpermitUrl");
      localStorage.removeItem("editworkpermitname");
      localStorage.removeItem("LocalPersonalidUrl");
      localStorage.removeItem("filename");
      localStorage.removeItem("LocaleditPersonalidUrl");
      localStorage.removeItem("get_date_of_today_return");
      localStorage.removeItem("get_date_of_today_return1");
      localStorage.removeItem("editfilename");
      localStorage.removeItem("localotherinfoUrl");
      localStorage.removeItem("othername");
      localStorage.removeItem("localeditotherinfoUrl");
      localStorage.removeItem("editothername");
      localStorage.removeItem("localPassportUrl");
      localStorage.removeItem("passportname");
      localStorage.removeItem("localeditPassportUrl");
      localStorage.removeItem("editpassportname");
      localStorage.removeItem("UserEditUserGp");
      localStorage.removeItem("TempUserGroup");
      localStorage.removeItem("UserEditRole");
      localStorage.removeItem("TempRole");
      localStorage.removeItem("UserEditRole");
      localStorage.removeItem("UserEditPer");
      localStorage.setItem("temp_tabs", 0);
      localStorage.setItem("FirstLogin", 2);
      localStorage.removeItem("locktab");
      for (let i = 0; i < self.items.length; i++) {
        self.items[i].model = false;
      }
    },
  },
};
</script>
<style scoped>

.notiText {
  color: #444444;
  font-size: 12px;
  font-family: "Kanit";
}

@media (max-width: 320px) {
  .headtxt {
    margin-left: -1rem !important;
    font-size: 13px !important;
  }

  .headddl {
    margin-left: -1rem !important;
  }
}

::v-deep .ex-menu a.highlighted.v-btn--active {
  background: rgb(255, 255, 255) !important;
  border-radius: 12px !important;
}

::v-deep .ex-menu .v-btn.highlighted {
  background: rgb(255, 255, 255) !important;
  border-radius: 12px !important;
}

::v-deep .ex-menu .v-btn.highlighted .v-btn__content {
  filter: invert(45%) sepia(99%) saturate(2580%) hue-rotate(164deg) brightness(98%) contrast(101%);
}

::v-deep .ex-menu .v-menu.highlighted {
  border-left: 6px solid #f99d20;
}

::v-deep .ex-menu a.highlighted.v-btn--active .v-btn__content {
  filter: invert(45%) sepia(99%) saturate(2580%) hue-rotate(164deg) brightness(98%) contrast(101%);
}

::v-deep .v-list-group .v-list-group__header.highlighted {
  /* border-left: 6px solid #f99d20; */
  background: rgb(255, 255, 255);
  border-radius: 12px !important;
}

::v-deep .highlighted .v-list-group__header {
  /* border-left: 6px solid #f99d20; */
  background: rgb(255, 255, 255);
  border-radius: 12px !important;
}

::v-deep .highlightedC .v-list-item__content {
  /* border-left: 6px solid #f99d20; */
  background: rgb(255, 255, 255);
  border-radius: 12px !important;
}

::v-deep .highlightedC .v-list-item__content .v-list-item--link .v-list-item__title {
  color: #0fa7d8;
}

::v-deep .highlighted .v-list-group__header .v-list-item__content .v-list-item__title {
  color: #0fa7d8;
}

::v-deep .v-list-item--link:before {
  background: rgba(0, 0, 0, 0.5);
}

::v-deep .theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
  opacity: 0;
}

/* ::v-deep .v-list-item--active {
  background: rgb(255, 255, 255);
  -webkit-text-fill-color: #0FA7D8; 
  fill:#0FA7D8;
}   */
::v-deep .v-list-item--hover {
  background: rgb(255, 255, 255);
  -webkit-text-fill-color: #0fa7d8;
  fill: #0fa7d8;
}

::v-deep .highlighted .v-list-item__action {
  filter: invert(45%) sepia(99%) saturate(2580%) hue-rotate(164deg) brightness(98%) contrast(101%);
}

::v-deep .highlighted .v-list-group__header .v-image {
  filter: invert(45%) sepia(99%) saturate(2580%) hue-rotate(164deg) brightness(98%) contrast(101%);
}

::v-deep .highlighted .v-list-group__header .v-list-item__icon {
  filter: invert(45%) sepia(99%) saturate(2580%) hue-rotate(164deg) brightness(98%) contrast(101%);
}

::v-deep .v-btn-toggle.highlightedT a.v-btn.v-btn--router {
  background-color: #0fa7d8 !important;
  -webkit-text-fill-color: #fff;
  opacity: 0.8;
}

::v-deep .v-btn-toggle .v-btn:hover {
  background-color: #0fa7d8 !important;
  -webkit-text-fill-color: #fff;
  opacity: 0.8;
}

::v-deep .v-list-item--active .v-image__image {
  filter: invert(45%) sepia(99%) saturate(2580%) hue-rotate(164deg) brightness(98%) contrast(101%);
}

::v-deep .v-btn-toggle>.v-btn.v-btn--hover {
  color: inherit;
  opacity: 0.8;
}

::v-deep .v-btn--active::before {
  opacity: 0;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
  height: 44px;
  min-width: 64px;
  padding: 0 16px;
}

::v-deep .v-list .v-list-item--active .v-icon {
  color: #fff;
}

::v-deep .v-list .v-list-item--active .v-list-item__content {
  color: #f89d1f;
}

::v-deep .v-list-item .v-list-item--active .v-list-item__title {
  color: #fff;
}

::v-deep .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 0%;
}

.lang-title {
  color: #f89d1f;
  font-size: 16px;
  font-family: Kanit;
}

.normal-flag[data-v-05fb4d45] {
  margin-right: -10px;
  -webkit-transform: scale(0.43);
}

::v-deep .mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: large;
  text-rendering: auto;
  line-height: inherit;
}

.initials {
  display: inline-block;
  width: 20px;
  font-size: 12px;
  font-weight: 30;
  overflow: hidden;
  word-break: break-all;
  height: 20px;
  line-height: 20px;
}

.bg-nav {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='318' height='1080' viewBox='0 0 318 1080'%3E%3Cdefs%3E%3CclipPath id='clip-path'%3E%3Cpath id='Path_3837' data-name='Path 3837' d='M318 0 H0 V1080 H318 Z' fill='%23fff'/%3E%3C/clipPath%3E%3ClinearGradient id='linear-gradient' x1='0.167' x2='0.817' y2='0.931' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%2321a8d6'/%3E%3Cstop offset='1' stop-color='%23007fc3'/%3E%3C/linearGradient%3E%3ClinearGradient id='linear-gradient-2' x1='0.5' x2='0.5' y2='1' xlink:href='%23linear-gradient'/%3E%3C/defs%3E%3Cg id='Group_214' data-name='Group 214' clip-path='url(%23clip-path)' stlye=''%3E%3Crect id='Rectangle_2407' data-name='Rectangle 2407' width='395' height='1080' transform='translate(-36)' fill='url(%23linear-gradient)'/%3E%3Cg id='Group_8463' data-name='Group 8463' transform='translate(-50 20)'%3E%3Ccircle id='Ellipse_442' data-name='Ellipse 442' cx='364' cy='364' r='364' transform='translate(-105 -500)' opacity='0.2' fill='url(%23linear-gradient-2)'/%3E%3Ccircle id='Ellipse_443' data-name='Ellipse 443' cx='364' cy='364' r='364' transform='translate(-268 -548)' fill='%23fff' opacity='0.1'/%3E%3Ccircle id='Ellipse_441' data-name='Ellipse 441' cx='364' cy='364' r='364' transform='translate(-138 -548)' fill='%23fff'/%3E%3Cpath id='Subtraction_82' data-name='Subtraction 82' d='M209.143 496.917a249.17 249.17 0 0 1-118.3-53.908A250.446 250.446 0 0 1 16 338.343 249.089 249.089 0 0 1 4.121 295.589a252.777 252.777 0 0 1 .958-95.877A248.81 248.81 0 0 1 42.7 110.276a250.747 250.747 0 0 1 109.993-90.62A248.662 248.662 0 0 1 199.617 5.082a252.4 252.4 0 0 1 96.837-.771 248.807 248.807 0 0 1 43.6 12.407 253.022 253.022 0 0 0-97.593.627 248.908 248.908 0 0 0-89.393 37.539A250.279 250.279 0 0 0 62.49 164.649a247.841 247.841 0 0 0-14.567 46.83A250.762 250.762 0 0 0 55.2 339.443a248.2 248.2 0 0 0 34.455 67.7 250.6 250.6 0 0 0 119.488 89.772Z' transform='translate(499.881 190.605) rotate(180)' fill='%23f9b052'/%3E%3Cpath id='Subtraction_81' data-name='Subtraction 81' d='M250 500.241a251.736 251.736 0 0 1-50.384-5.081 248.567 248.567 0 0 1-89.394-37.635A250.835 250.835 0 0 1 19.646 347.479a248.945 248.945 0 0 1-14.567-46.95 252.681 252.681 0 0 1 0-100.816A248.816 248.816 0 0 1 42.7 110.276a250.746 250.746 0 0 1 109.993-90.62A248.651 248.651 0 0 1 199.617 5.082a252.748 252.748 0 0 1 76.267-3.757 251.773 251.773 0 0 0-49.512 5.893 249 249 0 0 0-87.688 38.3A250.235 250.235 0 0 0 50.037 154.727 247.85 247.85 0 0 0 35.8 201.065a251.446 251.446 0 0 0-.249 98.141 247.72 247.72 0 0 0 35 86.521 249.6 249.6 0 0 0 194.86 114.045C260.3 500.084 255.116 500.241 250 500.241Z' transform='translate(485 180) rotate(180)' fill='%23f89d27'/%3E%3C/g%3E%3Ccircle id='Ellipse_449' data-name='Ellipse 449' cx='653' cy='653' r='653' transform='translate(-613 212)' fill='%23fff' opacity='0.1'/%3E%3C/g%3E%3C/svg%3E");
}

::v-deep .v-list--rounded .v-list-item,
.v-list--rounded .v-list-item::before,
.v-list--rounded .v-list-item>.v-ripple__container {
  border-radius: 12px !important;
}

::v-deep .v-list--rounded .v-list-item,
.v-list--rounded .v-list-item::after,
.v-list--rounded .v-list-item>.v-ripple__container {
  border-radius: 12px !important;
}

::v-deep .v-list--nav.v-list--dense .v-list-item:not(:last-child):not(:only-child),
.v-list--nav .v-list-item--dense:not(:last-child):not(:only-child),
.v-list--rounded.v-list--dense .v-list-item:not(:last-child):not(:only-child),
.v-list--rounded .v-list-item--dense:not(:last-child):not(:only-child) {
  margin-bottom: 6px;
}

.btnn:hover {
  -webkit-text-fill-color: #fff;
  opacity: 1.2;
}

.btnn:hover::before {
  opacity: 0.8;
  -webkit-text-fill-color: #fff;
}

::v-deep div.v-list-group.mt-1 div.v-list-group__header.v-list-item.v-list-item--link.theme--dark {
  margin: 0 !important;
}

::v-deep div.v-list-group.mt-1 div.v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--dark.highlighted {
  margin: 0 !important;
}

::v-deep .v-navigation-drawer__content {
  height: 100%;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

::v-deep .v-responsive__content {
  height: 100vh;
}

::v-deep ::-webkit-scrollbar-thumb {
  background: #ffffff00;
}
</style>
